const HomePageContent = ({ paraDetails }) => {
  return (
    <section className="home-page-content mb-3 mb-md-5 mt-xl-5">
      <div className="container">
        <div className="row">
          <h5 className="text-warning">FLORIDA TRAFFIC SCHOOL</h5>
          {Object.keys(paraDetails).map((paraData, pIndex) => (
            <div
              key={pIndex}
              className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              dangerouslySetInnerHTML={{ __html: paraDetails[paraData] }}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomePageContent;
